module.exports = __webpack_public_path__ + "img/roba_web.a0103133.png";